export default "__VITE_PUBLIC_ASSET__8c8e23e6__"